export {
    default,
    type ItemsContainerSectionProps,
} from './ItemsContainerSection';
